import React from "react";
import { AlertTriangle, Crown, ArrowRight } from "lucide-react";

const SubscriptionLimitModal = ({ isOpen, onClose, limitInfo, onUpgrade }) => {
  if (!isOpen) return null;

  const { feature, current, limit, planName } = limitInfo || {};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 max-w-md w-full mx-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center">
            <AlertTriangle className="w-6 h-6 text-red-600" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-gray-900">
              {feature?.charAt(0).toUpperCase() + feature?.slice(1)} Limit
              Reached
            </h3>
            <p className="text-sm text-gray-600">{planName} Plan</p>
          </div>
        </div>

        <div className="mb-6">
          <div className="bg-gray-50 rounded-lg p-4 mb-4">
            <div className="flex justify-between items-center">
              <span className="text-sm text-gray-600">Current Usage</span>
              <span className="font-semibold">
                {current}/{limit}
              </span>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mt-2">
              <div
                className="h-2 bg-red-500 rounded-full"
                style={{ width: "100%" }}
              ></div>
            </div>
          </div>

          <p className="text-gray-700 text-sm">
            You've reached your {feature} limit for the {planName} plan. Upgrade
            to continue adding more {feature}.
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition"
          >
            Close
          </button>
          <button
            onClick={onUpgrade}
            className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition flex items-center justify-center gap-2"
          >
            <Crown className="w-4 h-4" />
            Upgrade Plan
            <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionLimitModal;
